import PropTypes from 'prop-types';

import { PERMISSION_ACTIONS } from 'data/permissionActions';
import { PERMISSION_SUBJECTS } from 'data/permissionSubjects';
import GlobalLoader from 'components/GlobalLoader';
import usePermission from 'hooks/usePermission';

function WithPermissions({ subject, permissions, children, fallback = null }) {
  const { isAllowed, isFetching } = usePermission({
    permissions: permissions,
    subject: subject,
  });

  if (isFetching) {
    return <GlobalLoader isVisible={isFetching} />;
  } else if (isAllowed) {
    return children;
  } else {
    return fallback;
  }
}

WithPermissions.propTypes = {
  subject: PropTypes.oneOf(Object.values(PERMISSION_SUBJECTS)).isRequired,
  permissions: PropTypes.arrayOf(
    PropTypes.oneOf(Object.values(PERMISSION_ACTIONS))
  ).isRequired,
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node,
};

export default WithPermissions;
